import * as constants from '../constants';
import { Messages, MessageCategory } from '../models/index';

export interface SortMessageRequest {
  type: constants.SORT_MESSAGES_REQUEST;
  oldIndex: number;
  newIndex: number;
  categoryName: string;
}

export interface CategorySortMessageRequest {
  type: constants.CATEGORY_SORT_MESSAGES_REQUEST;
  oldIndex: number;
  newIndex: number;
}

export interface SortMessageCancelPrevRequest {
  type: constants.SORT_MESSAGES_CANCEL_PREV_REQUEST;
}

export interface CategorySortMessageCancelPrevRequest {
  type: constants.CATEGORY_SORT_MESSAGES_CANCEL_PREV_REQUEST;
}

export interface SortMessageSuccess {
  type: constants.SORT_MESSAGES_SUCCESS;
}

export interface CategorySortMessageSuccess {
  type: constants.CATEGORY_SORT_MESSAGES_SUCCESS;
}

export interface SortMessageFailure {
  type: constants.SORT_MESSAGES_FAILURE;
  message: string;
}

export interface CategorySortMessageFailure {
  type: constants.CATEGORY_SORT_MESSAGES_FAILURE;
  message: string;
}


export interface SortMessageInMemory {
  type: constants.SORT_MESSAGES_INMEMORY;
  messages: Messages;
  categoryName: string;
}

export interface CategorySortMessageInMemory {
  type: constants.CATEGORY_SORT_MESSAGES_INMEMORY;
  messageCategories: MessageCategory[];
}


export const sortMessageRequest =
  (oldIndex: number, newIndex: number, categoryName: string): SortMessageRequest => ({
    oldIndex,
    newIndex,
    categoryName,
    type: constants.SORT_MESSAGES_REQUEST,
  });

export const categorySortMessageRequest =
  (oldIndex: number, newIndex: number): CategorySortMessageRequest => ({
    oldIndex,
    newIndex,
    type: constants.CATEGORY_SORT_MESSAGES_REQUEST,
  });



export const sortMessagesSuccess = (): SortMessageSuccess => ({
  type: constants.SORT_MESSAGES_SUCCESS,
});


export const categorySortMessagesSuccess = (): CategorySortMessageSuccess => ({
  type: constants.CATEGORY_SORT_MESSAGES_SUCCESS,
});

export const sortMessagesFailure = (message: string): SortMessageFailure => ({
  message,
  type: constants.SORT_MESSAGES_FAILURE,
});


export const categorySortMessagesFailure = (message: string): CategorySortMessageFailure => ({
  message,
  type: constants.CATEGORY_SORT_MESSAGES_FAILURE,
});

export const sortMessagesInMemory =
  (messages: Messages, categoryName: string): SortMessageInMemory => ({
    messages,
    categoryName,
    type: constants.SORT_MESSAGES_INMEMORY,
  });

export const categorySortMessagesInMemory =
  (messageCategories: MessageCategory[]): CategorySortMessageInMemory => ({
    messageCategories,
    type: constants.CATEGORY_SORT_MESSAGES_INMEMORY,
  });


export const sortMessageCancelPrevRequest = (): SortMessageCancelPrevRequest => ({
  type: constants.SORT_MESSAGES_CANCEL_PREV_REQUEST,
});

export const categorySortMessageCancelPrevRequest = (): CategorySortMessageCancelPrevRequest => ({
  type: constants.CATEGORY_SORT_MESSAGES_CANCEL_PREV_REQUEST,
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/sortMessages.ts